import { FirebaseOptions } from 'firebase/app';
import { AppEnvironment } from './environment.types';
import { stagingClientSecrets } from './environment.client';

/** Public Firebase web config (staging project). Security: rules + App Check. */
export const STAGING_FIREBASE: FirebaseOptions = {
  apiKey: 'AIzaSyA_Z8oAkASpnhoqtZRBQun5pTmXScW9tiA',
  authDomain: 'timeflexrent-mvp-v01.firebaseapp.com',
  projectId: 'timeflexrent-mvp-v01',
  storageBucket: 'timeflexrent-mvp-v01.firebasestorage.app',
  messagingSenderId: '558737188944',
  appId: '1:558737188944:web:eddaafea229c62cee40955',
};

export function buildStagingEnvironment(envName: 'dev' | 'test'): AppEnvironment {
  return {
    production: false,
    envName,
    firebase: STAGING_FIREBASE,
    stripePublicKey: stagingClientSecrets.stripePublicKey,
    functionsRegion: 'europe-west1',
    googleMapsApiKey: stagingClientSecrets.googleMapsApiKey,
    googleMapsServerLinkResolve: true,
    appCheckRecaptchaSiteKey: stagingClientSecrets.appCheckRecaptchaSiteKey,
    firebaseAppCheckDebug: envName === 'dev',
    appCheckDebugToken: envName === 'test' ? stagingClientSecrets.appCheckDebugToken : undefined,
    publicOrigin: stagingClientSecrets.publicOrigin,
    fcmVapidKey: 'BN2Uv6a3zov0_ABHidJaaIdb0sl1-Z29UI2ZopqXoYPYZzLHnzIAcbvkVT8cIoKDjkjB_-oABUtOEr4scxzVGFI',
  };
}
